import _ from 'lodash'

export const mutations = {
    UPDATE_HELP_MEAN (state, data) {
        state.helpMean = data
    },
    SET_CURR_MENU (state, data) {
        state.currMenu = data
    },
    SET_CURR_MENU_PATH (state, data) {
        state.currMenuPath = data
    },
    SET_SHOW_MENU (state, data) {
        state.showMenu = data
    },
    SET_USER (state, data) {
        state.authUser = data
    },
    SET_MENU_LIST (state, data) {
        // if (!_.isEmpty(data)) {
        //     localStorage.setItem('menuList', JSON.stringify(data))
        // }
        state.menuList = data
    },
    SET_MENU_CLOSED (state, data) {
        let [ menu, child ] = state.currMenuPath
        let keys = [ menu, 'children', child, 'closed' ]
        _.set(state.menuList, keys, data)
    },
    SET_LAYOUT (state, data) {
        state.layout = data
    },
    SET_HELP_TYPE (state, data) {
        state.helpType = data
    },
    SET_HELP_TYPE_NAME (state, data) {
        state.helpTypeName = data
    }
}



// WEBPACK FOOTER //
// ./store/mutations.js